import type { InspectionBinBounds } from './inspectionBinBounds'

export interface InspectionGrid {
  xStart: number
  yStart: number
  binWidth: number
  binHeight: number
  columns: number
  rows: number
}

export function validInspectionBounds(
  bounds: InspectionBinBounds,
  columns: number,
  rows: number
): boolean {
  return (
    Object.values(bounds).every(Number.isInteger) &&
    bounds.x_start >= 0 &&
    bounds.y_start >= 0 &&
    bounds.x_end > bounds.x_start &&
    bounds.y_end > bounds.y_start &&
    bounds.x_end <= columns &&
    bounds.y_end <= rows
  )
}

export function inspectionSelectionBounds(
  grid: InspectionGrid,
  rect: { xStart: number; xEnd: number; yStart: number; yEnd: number }
): InspectionBinBounds | undefined {
  if (
    ![...Object.values(grid), ...Object.values(rect)].every(Number.isFinite) ||
    grid.binWidth <= 0 ||
    grid.binHeight <= 0
  )
    return undefined
  const bounds = {
    x_start: Math.floor((rect.xStart - grid.xStart) / grid.binWidth + 1e-7),
    x_end: Math.ceil((rect.xEnd - grid.xStart) / grid.binWidth - 1e-7),
    y_start: Math.floor((rect.yStart - grid.yStart) / grid.binHeight + 1e-7),
    y_end: Math.ceil((rect.yEnd - grid.yStart) / grid.binHeight - 1e-7),
  }
  return validInspectionBounds(bounds, grid.columns, grid.rows)
    ? bounds
    : undefined
}
